import { render, staticRenderFns } from "./UserContractAdminList.vue?vue&type=template&id=5c2da880"
import script from "./UserContractAdminList.vue?vue&type=script&lang=js"
export * from "./UserContractAdminList.vue?vue&type=script&lang=js"
import style0 from "./UserContractAdminList.vue?vue&type=style&index=0&id=5c2da880&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports